// extracted by mini-css-extract-plugin
export default {"RMD-Accounts":"RMDAccounts_RMD-Accounts__247bK","module":"RMDAccounts_module__StD+o"};